module.exports = __webpack_public_path__ + "img/error-404.ef642f89.gif";